/*
 * Anchor Autoworks: turns [data-delivery] elements into real arrival dates.
 * Business days only (Mon–Fri), skips holidays from theme settings, respects the order cutoff
 * in the store time zone. Runs once on load and when sections re-render in the editor / cart.
 */
(function () {
  var cfgEl = document.getElementById('AnchorDeliveryConfig');
  if (!cfgEl) return;
  var cfg;
  try {
    cfg = JSON.parse(cfgEl.textContent);
  } catch (e) {
    return;
  }
  var holidays = {};
  (String(cfg.holidays || '').match(/\d{4}-\d{2}-\d{2}/g) || []).forEach(function (d) {
    holidays[d] = true;
  });

  function iso(d) {
    return d.toISOString().slice(0, 10);
  }
  function isBusiness(d) {
    var w = d.getUTCDay();
    return w !== 0 && w !== 6 && !holidays[iso(d)];
  }
  function addBusiness(start, n) {
    var d = new Date(start.getTime());
    var count = 0;
    var guard = 0;
    while (count < n && guard < 400) {
      d.setUTCDate(d.getUTCDate() + 1);
      if (isBusiness(d)) count++;
      guard++;
    }
    return d;
  }
  function nowInStore() {
    try {
      var parts = {};
      new Intl.DateTimeFormat('en-CA', {
        timeZone: cfg.tz || undefined,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        hourCycle: 'h23',
      })
        .formatToParts(new Date())
        .forEach(function (p) {
          parts[p.type] = p.value;
        });
      return { y: +parts.year, m: +parts.month, d: +parts.day, h: +parts.hour };
    } catch (e) {
      var n = new Date();
      return { y: n.getFullYear(), m: n.getMonth() + 1, d: n.getDate(), h: n.getHours() };
    }
  }

  var t = nowInStore();
  var orderDay = new Date(Date.UTC(t.y, t.m - 1, t.d));
  if (!isBusiness(orderDay) || t.h >= (cfg.cutoff | 0)) orderDay = addBusiness(orderDay, 1);

  var fmt;
  try {
    fmt = new Intl.DateTimeFormat(cfg.locale || 'en-US', { weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC' });
  } catch (e) {
    fmt = new Intl.DateTimeFormat('en-US', { weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC' });
  }

  function render(root) {
    (root || document).querySelectorAll('[data-delivery]:not([data-delivery-done])').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10) || 0;
      var max = parseInt(el.getAttribute('data-max'), 10) || min;
      var tpl = el.getAttribute('data-template') || '';
      var target = el.querySelector('[data-delivery-text]') || el;
      if (!tpl) return;
      var minD = addBusiness(orderDay, min);
      var maxD = addBusiness(orderDay, Math.max(min, max));
      target.textContent = tpl.replace('[min]', fmt.format(minD)).replace('[max]', fmt.format(maxD));
      el.setAttribute('data-delivery-done', '');
    });
  }

  render();
  window.AnchorDelivery = { render: render };

  // Variant change (e.g. "Ships from: US warehouse"): swap in the server-rendered delivery block
  // for the new variant from the section HTML Dawn already fetched. No extra request.
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var data = event && event.data;
        if (!data || !data.html || !data.sectionId) return;
        var id = 'AnchorDelivery-' + data.sectionId;
        var source = data.html.getElementById ? data.html.getElementById(id) : null;
        var dest = document.getElementById(id);
        if (source && dest) {
          dest.innerHTML = source.innerHTML;
          render(dest);
        }
      });
    }
  } catch (e) {}
  if (window.MutationObserver) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        render();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
